import React, { useEffect, useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { CustodianDto } from 'appDtos';
import { Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AdministrationPaths } from '../../../shared/api/constants';
import { AppPaths } from '../../../shared/appConstants';
import { AlertComponent } from '../../../shared/components';
import { Loading } from '../../../shared/components';
import { useApi } from '../../../shared/hooks/useApi';
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError';

export function Custodians() {
  const [custodians, setCustodians] = useState<CustodianDto[]>([]);
  const [loading, setLoading] = useState(true);
  const API = useApi();
  const { setError, errorMessage } = useApiHandleError();
  const goTo = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await API.get(AdministrationPaths.GetCustodians());
        if (response.data) {
          setCustodians(response.data);
        }
      } catch (error) {
        setError(error)
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <PageHeader pageTitle='Asset Custodians' navPath={AppPaths.getCreateCustodian()} />
      <AlertComponent message={errorMessage} />
      {loading ? (
        <Loading />
      ) : (
        custodians.length > 0 ?
          <ListGroup numbered as="ol">
            {
              custodians.map((custodian, i) => (
                <ListGroup.Item key={custodian.custodianId} action as="li" className="d-flex justify-content-between align-items-start clicable" onClick={() => goTo(AppPaths.getCustodianDetail(custodian.custodianId))}>
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">{custodian.name ? custodian.name : `${custodian.firstName} ${custodian.lastName}`}</div>
                  </div>
                </ListGroup.Item>
              ))
            }
          </ListGroup>
          : (
            <AlertComponent message="No custodian has been created." variant="info" />
          )
      )}
    </Container>)
}
